import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import axios from "axios";

import { __API_URL__ } from "../SERVER_URL";

const createExternalMediaType = async ({ title, uploadType, trialId }) => {
  const token = localStorage.getItem("token");

  const payload = {
    title: title,
    type: uploadType,
    trial: trialId,
  };

  const { data } = await axios.post(
    `${__API_URL__}/api/photos/create_external_media_type/`,
    payload,
    {
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  return data;
};

const useCreateExternalMediaTypeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createExternalMediaType,
    onSuccess: (data) => {
      const message = data?.message || "Successfully created a new type.";
      toast.success(message);

      queryClient.invalidateQueries({ queryKey: ["external_media_types"] });
    },
    onError: (error) => {
      const errMsg =
        error?.response?.data?.message || error?.message || "Failed to send notifications.";
      toast.error(errMsg);
      console.error("Notification send failed:", error);
    },
  });
};

export default useCreateExternalMediaTypeMutation;
